// Animation name candidates for step-by-step animation
export const STEP_BY_STEP_ANIMATION_CANDIDATES = [
  'step_by_step',
  'step-by-step',
  'step by step',
  'Step_by_step',
  'Step_By_Step',
  'StepByStep',
];

// Animation name candidates for exploded view
export const EXPLODED_VIEW_ANIMATION_CANDIDATES = [
  'exploded_view',
  'exploded-view',
  'exploded view',
  'Exploded_View',
  'ExplodedView',
];

// Keywords to match in animation names for step-by-step
export const STEP_BY_STEP_REQUIRED_KEYWORDS = ['step', 'by', 'step'];

// Keywords to match in animation names for exploded view
export const EXPLODED_VIEW_REQUIRED_KEYWORDS = ['exploded', 'view'];

// Step-based camera animation settings
export const CAMERA_TRANSITION_DURATION = 1.5; // seconds
export const ANIMATION_SEGMENT_PAUSE_DURATION = 0.5; // seconds after segment completes
